{
  "audit_model": {
    "emit": [
      "AUDIT.BRIDGE_RECEIPT",
      "AUDIT.APPEND_ONLY_LOG",
      "AUDIT.SUPERUSER_OVERRIDE"
    ]
  },
  "bridge_id": "G1.EPISTEMIC_TO_EXEC_TEXT2HTTP",
  "cost_model": {
    "per_call": 10,
    "type": "token",
    "unit": "risk_budget"
  },
  "fills": [
    "SEPARATE.MIXED_SQUARE.EPISTEMIC_TO_EXEC"
  ],
  "generator": "G1",
  "mode": "contained",
  "notes": "This bridge would allow untrusted epistemic content to directly invoke HTTP execution. It is intentionally NOT admitted in any regime in this spinout.",
  "requires_witness": [
    "WITNESS.SUPERUSER_OVERRIDE"
  ],
  "seam": "epistemic↛authority"
}
